export const listReportTypes = `
   query listReportTypes {
       listReportTypes {
           items {
              id
              dataAvailableEnd
              dataAvailableStart
              defaultColumns
              livemode
              name
              updated
              version
           }
       }
   }
`;

export const getReportType = `
   query getReportType($id:ID!) {
       getReportType(id:$id) {
         id
         dataAvailableEnd
         dataAvailableStart
         defaultColumns
         livemode
         name
         updated
         version
       }
}`;
